import ROUTES from '../routes';
import TransactionMonitoringRulesList from '../hoc/transaction-monitoring-rules/transaction-monitoring-rules';
import TransactionMonitoringRuleForm from '../hoc/transaction-monitoring-rules/form';

const TransactionMonitoringRulesRoutes = {
  path: ROUTES.TRANSACTION_MONITORING_RULES ,
  element: <TransactionMonitoringRulesList />,
  children: [
    {
      path: ROUTES.TRANSACTION_MONITORING_RULES_CREATE,
      element: <TransactionMonitoringRuleForm />,
    },
    {
      path: ROUTES.TRANSACTION_MONITORING_RULES_EDIT,
      element: <TransactionMonitoringRuleForm />,
    },
  ],
};

export default TransactionMonitoringRulesRoutes;
